import jQuery from 'jquery';
// import MouseFollower from "mouse-follower";
import gsap from "gsap";
import { DrawSVGPlugin } from "./vendor/gsap/DrawSVGPlugin";
// import SplitText from 'gsap/SplitText';
import SmoothScrollbar from 'smooth-scrollbar';
import ScrollTrigger from "gsap/ScrollTrigger";
// import Magnetic from "../js/vendor/magnetic";
import ScrollTriggerPlugin from './vendor/ScrollTriggerPlugin';
import SoftScrollPlugin from './vendor/SoftScrollPlugin';

import Swiper from 'swiper/bundle';

import { Fancybox } from "@fancyapps/ui";

SmoothScrollbar.use(ScrollTriggerPlugin, SoftScrollPlugin);
// gsap.registerPlugin(SplitText);

window.$ = window.jQuery = jQuery;

// Check if is mobile device
function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};


// // Loader
// $(window).on('load', function() {
//   setTimeout(function() { 
// 	 $( ".my-loader" ).removeClass( "-visible" );
//   }, 450);
// });

var swiper = new Swiper(".my-feed-swiper", {
  slidesPerView: 1,
  spaceBetween: 16,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  // lazy: true,
  // allowTouchMove: false,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      freeMode: {
        enabled: true,
        momentumVelocityRatio: 0.3,
        freeModeMomentum: false,
        minimumVelocity: 0,
        sticky: false,
      },
    },
    1400: {
      slidesPerView: 3,
      freeMode: {
        enabled: true,
        momentumVelocityRatio: 0.3,
        freeModeMomentum: false,
        minimumVelocity: 0,
        sticky: false,
      },
    },
    1600: {
      slidesPerView: 4,
      spaceBetween: 24,
      freeMode: {
        enabled: true,
        momentumVelocityRatio: 0.3,
        freeModeMomentum: false,
        minimumVelocity: 0,
        sticky: false,
      },
    },
  },
});


// Fancybox
Fancybox.bind('[data-fancybox="insta"]', {
  infinite: true,
  showClass: "fancybox-fadeIn",
  hideClass: "fancybox-fadeOut",

  Toolbar: false,
  autoFocus: false,
  backFocus: false,
  trapFocus: false,
  placeFocusBack: false,

  hash: false,

  click: true,
  closeButton: "top",

  Image: {
    // Disable animation from/to thumbnail on start/close
    zoom: false,

    // Disable zoom on scroll event
    wheel: false,

    // Disable zoom on image click
    click: false,
  },

  Carousel: {
    Navigation: false,
  }
});

// Fancybox
Fancybox.bind('[data-fancybox]', {
  infinite: true,
  showClass: "fancybox-fadeIn",
  hideClass: "fancybox-fadeOut",

  Toolbar: false,
  autoFocus: false,
  backFocus: false,
  trapFocus: false,
  placeFocusBack: false,

  hash: false,

  click: true,
  closeButton: "top",

  Image: {
    // Disable animation from/to thumbnail on start/close
    zoom: false,

    // Disable zoom on scroll event
    wheel: false,

    // Disable zoom on image click
    click: false,
  },

  Carousel: {
    Navigation: false,
  }
});

Fancybox.defaults.Hash = false;


// DRAWER 100VH INCLUDING URL BAR

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});



// ============= REMOVE ALL # FROM URL BAR WHEN CLICKING LINK
//Get all the hyperlink elements
var links = document.getElementsByTagName("a");

//Browse the previously created array
Array.prototype.forEach.call(links, function(elem, index) {
  //Get the hyperlink target and if it refers to an id go inside condition
  var elemAttr = elem.getAttribute("href");
  if(elemAttr && elemAttr.includes("#")) {
    //Replace the regular action with a scrolling to target on click
    elem.addEventListener("click", function(ev) {
      ev.preventDefault();
      //Scroll to the target element using replace() and regex to find the href's target id
      document.getElementById(elemAttr.replace(/#/g, "")).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
          });
    });
  }
});


gsap.registerPlugin(DrawSVGPlugin);

// if (!isMobileDevice()) {  

  // Mouse follower
  // MouseFollower.registerGSAP(gsap);
  // const cursor = new MouseFollower({
  //     el: null,
  //     container: document.body,
  //     className: 'my-cursor',
  //     innerClassName: 'my-cursor-inner',
  //     textClassName: 'my-cursor-text',
  //     mediaClassName: 'my-cursor-media',
  //     mediaBoxClassName: 'my-cursor-media-box',
  //     iconSvgClassName: 'my-svgsprite',
  //     iconSvgNamePrefix: '-',
  //     iconSvgSrc: '../img/svgsprites.svg',
  //     dataAttr: 'cursor',
  //     hiddenState: '-hidden',
  //     textState: '-text',
  //     iconState: '-icon',
  //     activeState: '-active',
  //     mediaState: '-media',
  //     stateDetection: {
  //         '-pointer': 'a,button',
  //         '-hidden': 'iframe'
  //     },
  //     visible: true,
  //     visibleOnState: false,
  //     speed: 0.55,
  //     ease: 'expo.out',
  //     overwrite: true,
  //     skewing: 0,
  //     skewingText: 2,
  //     skewingIcon: 2,
  //     skewingMedia: 2,
  //     skewingDelta: 0.001,
  //     skewingDeltaMax: 0.15,
  //     stickDelta: 0.15,
  //     showTimeout: 20,
  //     hideOnLeave: true,
  //     hideTimeout: 300,
  //     hideMediaTimeout: 300
  // });
// };


// ============================================= SMOOTH SCROLL & GSAP ====================================================

//Disable mobile resize to fix the bug on mobile with the URL bar
ScrollTrigger.config({ ignoreMobileResize: true });


//Reload page for GSAP if the mobile oriantation has changed
function doOnOrientationChange() {
    switch(window.orientation) {
      case 90:
        location.reload();
        break;
      case -90:
        location.reload();
        break;
      case 0:
        location.reload();
        break;
      case 180:
        location.reload();
        break;
      default:
        break;
    }
}

window.addEventListener('orientationchange', doOnOrientationChange);




// Enable smooth scall on Desktop
if (!isMobileDevice()) {  
	// Init smooth scrollbar
	const view = document.querySelector('.my-layout');
	const scrollbar = SmoothScrollbar.init(view, {
	    renderByPixels: true,
	    damping: 0.085
	});

  // Smooth scroll autoscroll for links with class autoscroll-link
  (function($) {
    $(".autoscroll-link").click(function(e){
        var href = $(this).attr('href');
        scrollbar.scrollIntoView(document.querySelector(href), {
        offsetTop: 0,
        alignToTop: true,
      });
    });
  })(jQuery);
};


ScrollTrigger.matchMedia({
	"(min-width: 1024px)": function() {
    // Parallax images
    (function () {
      let contain = gsap.utils.toArray('.parallax-top');
          
        contain.forEach((item, index) => {

        let parallax = item.querySelector('.my-parallax');                 

        let tl = new gsap.timeline({
          scrollTrigger: {
            trigger: item,
            scrub: true,
            start: "top bottom",
            end: "bottom top",
          }
        });

        tl.fromTo(parallax, {
            yPercent: -15,
            // yPercent: 3.5,
            // scale: 1
            ease: "none",
          },{ 
            yPercent: 10,
            // yPercent: -15,
            // scale: 1.1,
            // duration: 1,
            ease: "none",
          }, 0);
        });
    })();

    (function () {
      let contain = gsap.utils.toArray('.parallax-bottom');
          
        contain.forEach((item, index) => {

        let parallax = item.querySelector('.my-parallax');                 

        let tl = new gsap.timeline({
          scrollTrigger: {
            trigger: item,
            scrub: true,
            start: "top bottom",
            end: "bottom center",
          }
        });

        tl.fromTo(parallax, {
            yPercent: -15,
            // scale: 1,
            ease: "none",
          },{ 
            yPercent: 7.5,
            // scale: 1.075,
            // duration: 1,
            ease: "none",
          }, 0);
        });
    })();

    // Logo animation
    $(window).on('load', function() {
      (function () {
        var full = document.querySelector('.loader-logo');
        var chair = document.querySelector('#logoCircle');
        var logomark = document.querySelector('#logomark');
        var logoText = document.querySelector('#logoText');

        const tl = gsap.timeline({
          onComplete: function(){ 
            $( ".my-loader" ).removeClass( "-visible" );

            (function () {
              const heroImg = document.querySelector('.parallax-top');
              const heading = document.querySelector('.my-hero-header h1');
              const location = document.querySelector('.my-hero-location');

              const tl = new gsap.timeline();

              tl.fromTo(heroImg, {
                  yPercent: 15,
                },{ 
                  yPercent: 0,
                  duration: 0.8,
                  delay: 0.1,
                  ease: "expo.easeOut",
              }, 0);

              tl.fromTo(heading, {
                  yPercent: 60,
                },{ 
                  yPercent: 0,
                  duration: 0.8,
                  ease: "expo.easeOut",
              }, 0);

              tl.fromTo(location, {
                  opacity: 0,
                  yPercent: 100,
                },{ 
                  opacity: 1,
                  yPercent: 0,
                  duration: 0.7,
                  delay: 0.65,
                  ease: "expo.easeOut",
              }, 0);
            })();
          },
        });

        tl.set(logomark, {
          xPercent: 100,
        });

        tl.fromTo(logomark, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          duration: 0.6,
          ease: "expo.easeOut",
        }, 0);

        tl.fromTo(chair, {
          drawSVG:"44.4%",
        }, {
          drawSVG:"100%",
          duration: 1.1,
          delay: 0,
          ease: "expo.easeIn",
        }, 0);

        tl.fromTo(logomark, {
          xPercent: 100,
        }, {
          xPercent: 0,
          duration: 1,
          delay: 1,
          ease: "Power3.easeOut",
        }, 0);

        tl.fromTo(logoText, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          duration: 0.6,
          delay: 1.4,
          ease: "expo.easeOut",
        }, 0);

        tl.fromTo(full, {
          autoAlpha: 1,
        }, {
          autoAlpha: 0,
          duration: 0.4,
          delay: 2.75,
          ease: "expo.easeOut",
        }, 0);

      })();
    });


    // About section images
    (function () {
      let contain = gsap.utils.toArray('.my-about-image');
          
        contain.forEach((item, index) => {

        // let zoom = item.querySelector('img');                 

        let tl = new gsap.timeline({
          scrollTrigger: {
            trigger: item,
            scrub: false,
            // start: "top bottom",
            // end: "bottom top",
          }
        });

        tl.fromTo(item, {
            // scale: 1,
            y: 150,
            opacity: 0,            
          },{ 
            // scale: 1.07,
            y: 0,
            opacity: 1,
            duration: 0.7,
            ease: "expo.easeOut",
          }, 0);
        });
    })();

    // About section text
    (function () {
      let contain = gsap.utils.toArray('.my-about-text');
          
        contain.forEach((item, index) => {

        let tl = new gsap.timeline({
          scrollTrigger: {
            trigger: item,
            scrub: false,
            // start: "top bottom",
            // end: "bottom top",
          }
        });

        tl.fromTo(item, {
            // scale: 1,
            y: 150,
            opacity: 0,
          },{ 
            // scale: 1.07,
            y: 0,
            opacity: 1,
            duration: 0.7,
            ease: "expo.easeOut",
          }, 0);
        });
    })();

    // Feed section animation
    (function () {
      const feed = document.querySelector('.my-feed');

      let tl = new gsap.timeline({
        scrollTrigger: {
          trigger: feed,
          scrub: false,
        }
      });

      tl.fromTo(feed, {
        y: 150,
        opacity: 0,
      },{ 
        y: 0,
        opacity: 1,
        duration: 0.7,
        ease: "expo.easeOut",
      }, 0);
    })();

    // Feed section animation
    (function () {
      const contact = document.querySelector('.my-contact');

      let tl = new gsap.timeline({
        scrollTrigger: {
          trigger: contact,
          scrub: false,
        }
      });

      tl.fromTo(contact, {
        y: 150,
        opacity: 0,
      },{ 
        y: 0,
        opacity: 1,
        duration: 0.7,
        ease: "expo.easeOut",
      }, 0);
    })();
	},

  "(max-width: 1023px)": function() {


    // Logo animation
    $(window).on('load', function() {
      (function () {
        var full = document.querySelector('.loader-logo');
        var chair = document.querySelector('#logoCircle');
        var logomark = document.querySelector('#logomark');
        var logoText = document.querySelector('#logoText');

        const tl = gsap.timeline({
          onComplete: function(){ 
            $( ".my-loader" ).removeClass( "-visible" );
          },
        });

        tl.set(logomark, {
          xPercent: 100,
        });

        tl.fromTo(logomark, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          duration: 0.6,
          ease: "expo.easeOut",
        }, 0);

        tl.fromTo(chair, {
          drawSVG:"44.4%",
        }, {
          drawSVG:"100%",
          duration: 1.1,
          delay: 0,
          ease: "expo.easeIn",
        }, 0);

        tl.fromTo(logomark, {
          xPercent: 100,
        }, {
          xPercent: 0,
          duration: 1,
          delay: 1,
          ease: "Power3.easeOut",
        }, 0);

        tl.fromTo(logoText, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          duration: 0.6,
          delay: 1.4,
          ease: "expo.easeOut",
        }, 0);

        tl.fromTo(full, {
          autoAlpha: 1,
        }, {
          autoAlpha: 0,
          duration: 0.4,
          delay: 2.75,
          ease: "expo.easeOut",
        }, 0);

      })();
    });

    // Parallax images
    (function () {
      let contain = gsap.utils.toArray('.parallax-top');
          
        contain.forEach((item, index) => {

        let parallax = item.querySelector('.my-parallax');                 

        let tl = new gsap.timeline();

        tl.to(parallax, {
          yPercent: 0,
          ease: "none",
        }, 0);
      });
    })();

    (function () {
      let contain = gsap.utils.toArray('.parallax-bottom');
          
        contain.forEach((item, index) => {

        let parallax = item.querySelector('.my-parallax');                 

        let tl = new gsap.timeline();

        tl.to(parallax, {
          yPercent: 0,
          ease: "none",
        }, 0);
      });
    })();

    // About section images
    (function () {
      let contain = gsap.utils.toArray('.my-about-image');
          
        contain.forEach((item, index) => {              

        let tl = new gsap.timeline();

        tl.to(item, {
          y: 0,
          opacity: 1,            
        }, 0);
      });
    })();

    // About section text
    (function () {
      let contain = gsap.utils.toArray('.my-about-text');
          
        contain.forEach((item, index) => {

        let tl = new gsap.timeline();

        tl.to(item, {
          y: 0,
          opacity: 1,            
        }, 0);
      });
    })();

    // Feed section animation
    (function () {
      const feed = document.querySelector('.my-feed');

      let tl = new gsap.timeline();

      tl.to(feed, {
        y: 0,
        opacity: 1,
      }, 0);
    })();

    // Feed section animation
    (function () {
      const contact = document.querySelector('.my-contact');

      let tl = new gsap.timeline();

      tl.to(contact, {
        y: 0,
        opacity: 1,
      }, 0);
    })();
  },

	"all": function () {
    // Side scrolling text animations
    (function () {
      let marqueeRow = gsap.utils.toArray('.my-scroll-text');

      marqueeRow.forEach((item, index) => {
        let distance = item.clientWidth;

        const tl = new gsap.timeline({
          scrollTrigger: {
            trigger: marqueeRow,
            start: "top bottom",
            end: "bottom top",
            toggleActions: "play pause play pause",

            onLeave: () => {
              tl.pause()
            },
            onEnterBack: () => {
              tl.play()
            }
          },
        });

        tl.to(item, 8, {
          ease: "none",
          xPercent: -100, //move each box 100% to right
          modifiers: {
            x: gsap.utils.unitize(x => parseFloat(x) % distance) //force x value to be between 0 and 500 using modulus
          },
          repeat: -1
        });
      });
    })();
	}
});


// Refresh GSAP on window resize on Desktop 
if (!isMobileDevice()) {  
	$(window).resize(function() {
		ScrollTrigger.refresh();
		ScrollTrigger.update();
	});
}